const recaptchaManager = require('od-modules/users/recaptcha.js');
const loginvalidator = require('od-modules/users/login_validator');
const trackingUtils = require('od-modules/utils/tracking.utils');
const tagManagement = require('od-modules/utils/tag_management.utils');
const socialLogin = require('od-modules/users/social_login');
const socialLoginButtons = {
    facebook: require('components/user_area/social_buttons/facebook_login_button.html'),
    google: require('components/user_area/social_buttons/google_login_button.html'),
};
const BaseView = require('components-framework/view/base.view');
const withRenderedMain = require('components-framework/view/with_rendered_main');
const userHelper = require('od-modules/helpers/user');

// TODO: Decouple logic from login widget!
const TO_TRIP_DETAILS_EVENT_NAME = 'navigateToTripDetails';
const TO_MY_TRIPS_EVENT_NAME = 'navigateToMyTrips';
const MY_TRIP_DETAILS_CATEGORY = 'my_area_trips_details';
const ACCESS_MY_TRIPS_DETAILS_ACTION = 'access_my_trips_details';
const NEXT_STEPS_ACTION = 'next_steps';
const trackMyTripDetailsAccess = (logged) => {
    const labelSuffix = logged ? 'A' : 'B';
    trackingUtils.trackEventWithCategory(MY_TRIP_DETAILS_CATEGORY, ACCESS_MY_TRIPS_DETAILS_ACTION,
        `access_my_trips_successful_${labelSuffix}`);
};
const trackNextSteps = (flow, logged) => {
    const labelSuffix = (logged ? '' : 'not_') + 'logged';
    trackingUtils.trackEventWithCategory(`${flow}_confirmation_page_confirmed`, NEXT_STEPS_ACTION, `my_trips_clicks_${labelSuffix}`);
};
// End coupling.

const renderCaptcha = function(selector, resumeSubmitRequest) {
    const isRecaptchaEnabled = (selector !== 'recaptchaLogin') ? Odigeo.AB.isRecaptchaEnabled
        : Odigeo.AB.isRecaptchaLoginEnabled;
    if (isRecaptchaEnabled && recaptchaManager.isGRecaptchaLoaded && !this.model.get(selector)) {
        this.model.recaptchaWidgetID[selector] = recaptchaManager.gRecaptchaRender(this.$el.find(this.selectors[selector]).get(0),
            Odigeo._.bind(this.recaptchaExecutionCallback, this, selector, resumeSubmitRequest),
            Odigeo.UserArea.recaptchaSiteKey);
        this.model.set(selector, true);
    }
};

module.exports = withRenderedMain(BaseView.extend({
    initialize: function() {
        this.model.trackCategory = this.id === 'my-trips-login-form' ? 'sso_sign_in_trips' : 'sso_module';
        this.model.trackPage = this.id === 'my-trips-login-form' ? 'sso_trips' : 'sso';
        socialLogin.init(Odigeo._.bind(this._login, this), Odigeo._.bind(this._showSocialLoginError, this),
            this.id, this.$el.find(this.selectors.socialLoginContainer).data('pattern'));

        if ((Odigeo.AB.isRecaptchaEnabled || Odigeo.AB.isRecaptchaLoginEnabled) && !recaptchaManager.isGRecaptchaLoaded) {
            recaptchaManager.init();
        }

        this.$el.find(this.selectors.loginUserWithFacebook).html(this.getSocialLoginButtonTemplate('facebook'));
        this.$el.find(this.selectors.loginUserWithGoogle).html(this.getSocialLoginButtonTemplate('google'));
        this.checkLogged();
        this.checkNoModalWidget();
    },

    selectors: {
        createUserButton: '.create_user_button',
        socialLogginError: '.social_login_error',
        modalView: '.modal_view',
        modalViewContent: '.modal_view_content',
        userLogin: '.user_login',
        userLoginHeader: '.user_login_header',
        userLoginContent: '.user_login_content',
        closeLogin: '.close_login',
        recoverPassword: '.recover_password',
        forgotPassword: '.forgot_password',
        backToLogin: '.back_to_login',
        emailRecoverPasswordInput: '.email_recover_password_input',
        recoverPasswordButton: '.recover_password_button',
        recoverPasswordEmail: '.recover_password_email',
        userEmail: '.user_email',
        recoverPasswordForm: '.recover_password_form',
        recoverPasswordWaiting: '.recover_password_waiting',
        recoverPasswordInformation: '.recover_password_information',
        loginSubmit: '.login_button',
        loginUserWithPassword: '.loginUserWithPassword',
        emailInput: '.email_input',
        passwordInput: '.password_input',
        passwordIcon: '.password_icon',
        loginNameIcon: '.login_name_icon',
        loginWaiting: '.login_waiting',
        loginSuccess: '.login_success',
        loginConnectors: '.login_connectors',
        loginConnectorsClose: '.login_connectors_close',
        registerFooter: '.register_footer',
        headerDialog: '.header_dialog',
        loginFacebookButton: '.login_facebook_button',
        loginGoogleButton: '.login_google_button',
        loginFacebookError: '.login_facebook_error',
        loginGoogleError: '.login_google_error',
        loginSocialError: '.login_social_error',
        socialError: '.social_error',
        socialLoginContainer: '.social_login_container',
        emailLoginContainer: '.email_login_container',
        emails: 'input[data-name="email"]',
        recaptchaLogin: '.g_recaptcha_login',
        recaptchaPassRecovery: '.g_recaptcha_pass_recovery',
        loginError: '.login_error',
        passRecoveryError: '.pass_recovery_error',
        modalArtifacts: '.modal_artifact',
        loginUserSocial: '.login_user_social',
        loginUserWithFacebook: '.login_user_with_facebook',
        loginUserWithGoogle: '.login_user_with_google',
        prismaInput: '.prisma_input_group',
    },

    events: {
        'tap .login_connectors_close': 'closeConnectorsLayer',
        'tap .login_connectors': 'stopPropagationClose',
        'tap .close_login': 'closeConnectorsLayer',
        'input .password_input': 'showPasswordCharsIcon',
        'tap .password_icon': 'changePasswordCharsViewer',
        'tap .forgot_password': 'openRecoverPasswordForm',
        'tap .back_to_login': 'onBackToLogin',
        'tap .recover_password_button': 'recoverPassword',
        'tap .login_button': 'onLoginSubmit',
        'keyup .user_login': 'keyPressed',
        'tap .register_footer': 'openRegisterForm',
        'tap .login_facebook_button': 'onLoginFacebook',
        'tap .login_google_button': 'onLoginGoogle',
        'focus .prisma_input_group': 'onFocusInput',
        'blur .prisma_input_group': 'onBlurInput',
        'change .email_input': 'onChangeInput',
        'change .password_input': 'onChangeInput',
    },

    getSocialLoginButtonTemplate: function(type) {
        const template = Odigeo._.template(socialLoginButtons[type], Odigeo.Utils.getTmplSettings({variable: 'data'}));
        return template({keys: this.keys});
    },

    _tracktCustomVar: function(logged) {
        // Analytics: custom variable tracking
        Odigeo.trigger('analytics:tracking', {
            type: 'trackCustomVariable',
            data: {
                index: 50,
                name: 'SSO',
                value: 'SSO_' + (logged ? '1' : '0'),
                scope: 2,
                customDimension: 15,
            },
        });
    },

    openRegisterForm() {
        this.trackEvent(this.model.trackCategory, 'sign_in', 'go_to_register');
        Odigeo.trigger(this.id + ':openRegister');
    },

    keyPressed: function(e) {
        if ((e.keyCode ? e.keyCode : e.which) === 13) {
            this.loginWithPassword();
        }
    },

    _trackError: function(error) {
        const label = error.index === 'email' ?
            'sso_email_incorrect_format_error' : 'sso_pwd_pci_compliance_error';
        this.trackEvent(this.model.trackCategory, 'sign_in', label);
    },

    _addHiddenInput: function(name, value) {
        this.$el.find(this.selectors.loginUserWithPassword).append(
            $('<input />').attr('type', 'hidden')
                .attr('name', name)
                .attr('value', value)
        );
    },

    loginError: function(data) {
        if (Odigeo.AB.isRecaptchaLoginEnabled) {
            recaptchaManager.gRecaptchaReset(this.model.recaptchaWidgetID['recaptchaLogin']);
        }
        return Odigeo._.startsWith(data && data.messageError, 'UNL') ? this.dealWithUnlError() : this.dealWithSsoError(data);
    },

    dealWithUnlError: function() {
        const texts = Odigeo.UIElements.translations.unl.lightboxTextsVelocityRules;
        Odigeo.UIElements.showLightboxWarning('od-passenger-lightbox-logout',
            Odigeo._.bind(this.removeAllLayers, this),
            Odigeo._.bind(this.removeAllLayers, this),
            Odigeo._.extend({}, texts, {description: texts.description}));
    },

    removeAllLayers: function() {
        Odigeo.trigger('closeAllPopUps');
        this.$el.find(this.selectors.loginWaiting).addClass('hidden');
        this.closeConnectorsLayer();
    },

    dealWithSsoError(data) {
        let error = this.model.errors[data && data.messageError] || 'requestError';
        const loginRequestedType = Odigeo.Session.get('loginRequested');
        if (error === 'loginError'
            && (loginRequestedType === socialLogin.socialLoginType.facebook
                || loginRequestedType === socialLogin.socialLoginType.google)) {
            error = this.model.errors.AUTH_010;
        }
        const $selector = Odigeo._.includes(['notverifiedaccount', 'legacyUser', 'emailError', 'socialError', 'socialErrorFacebook',
            'socialErrorGoogle'], error) ?
            this.$el.find(this.selectors).emailInput : this.$el.find(this.selectors.passwordInput);
        const lastLoginEmailUsed = this.options.lastLoginEmailUsed || this.$el.find(this.selectors.emailInput).val();
        const socialError = Odigeo._.includes(['permissions', 'authErrorFacebook', 'authErrorGoogle', 'format', 'tokenError',
            'tokenErrorFacebook', 'tokenErrorGoogle', 'emailMatching'], error) ||
            (error === 'requestError' && data.action.toLowerCase().indexOf('facebook') > -1);

        if (error === 'legacyUser' && !Odigeo._.isEmpty(lastLoginEmailUsed) && lastLoginEmailUsed.length > 0) {
            this.model.isLegacyUser = true;
        }
        this.showModalLoginForm();

        if (error.indexOf('recaptcha') !== -1) {
            this.showGenericError(this.$el.find(this.selectors.loginError), 'recaptchaerror');
            this.trackRecaptchaError('odigeo_recaptcha_error_sign-on');
        } else if (error === 'remoteError') {
            this.showGenericError(this.$el.find(this.selectors.loginError), 'remoteerror');
        } else if (socialError) {
            var loginType = Odigeo.Session.get('loginRequested');
            if (error.indexOf('Error') !== -1) {
                error = 'error';
            }
            this.trackEvent(this.model.trackCategory, 'sign_in',
                'sso_email_authentication_' + loginType + '_error');
            this._showSocialLoginError(error, loginType);
        } else {
            loginvalidator.showError($selector.data(error), $selector.closest('.input_wrapper'));
            this.trackEvent(this.model.trackCategory, 'sign_in', this._findLabelTracking(error));
        }
    },

    showGenericError: function($msgElem, errAttr) {
        const err = $msgElem.data(errAttr);
        $msgElem.find('.msg_content').text(err);
        $msgElem.removeClass('odf-hidden');
    },

    hideGenericError: function() {
        this.$el.find(this.selectors.loginError).addClass('odf-hidden');
        this.$el.find(this.selectors.passRecoveryError).addClass('odf-hidden');
    },

    trackRecaptchaError: function(operation) {
        this.trackEvent(Odigeo.Utils.isHomePage() ? 'home' : Odigeo.History.getPageNameFromFragment(),
            'recaptcha_error', operation);
    },

    _findLabelTracking: function(error) {
        switch (error) {
            case 'legacyUser':
                return 'sso_legacy_login_error';
            case 'invalid':
                return 'sso_pwd_pci_compliance_error';
            case 'socialErrorFacebook':
                return 'sso_email_already_used_facebook_error';
            case 'socialErrorGoogle':
                return 'sso_email_already_used_google_error';
            case 'socialError':
                return 'sso_email_already_used_social_error';
            default:
                return 'sso_wrong_signin_credentials_error';
        }
    },

    requestRecoverPasswordError: function(data) {
        const error = data.messageError && this.model.errors[data.messageError] || '';

        if (Odigeo.AB.isRecaptchaEnabled) {
            recaptchaManager.gRecaptchaReset(this.model.recaptchaWidgetID['recaptchaPassRecovery']);
        }
        this.$el.find(this.selectors.recoverPasswordWaiting).addClass('hidden');
        this.$el.find(this.selectors.recoverPassword).removeClass('hidden');
        if (error.indexOf('recaptcha') !== -1) {
            this.showGenericError(this.$el.find(this.selectors.passRecoveryError), 'recaptchaerror');
            this.trackRecaptchaError('odigeo_recaptcha_error_forgot-pass');
        } else if (error === 'remoteError') {
            this.showGenericError(this.$el.find(this.selectors.passRecoveryError), 'remoteerror');
        } else {
            loginvalidator.showError(this.$el.find(this.selectors.emailRecoverPasswordInput).data('requestError'),
                this.$el.find(this.selectors.recoverPasswordEmail));
            this.trackEvent(this.model.trackCategory, 'sign_in', 'sso_request_error');
        }
    },

    isAccountBlocked: function(data) {
        if (this.model.errors[data && data.messageError] === 'accountBlocked') {
            this.model.set('isBlockedUser', true);
            var emailAttemp = this.$el.find(this.selectors.emailInput).val();
            this.$el.find(this.selectors.loginWaiting).addClass('hidden');
            Odigeo.Session.set('loginDetails', emailAttemp);
            Odigeo.Router.navigate('accountblocked');
            return true;
        }
        return false;
    },

    openLoginForm: function() {
        const $emailInput = this.$el.find(this.selectors.emailInput);
        const $pwdInput = this.$el.find(this.selectors.passwordInput);
        const isCheckUserMail = userHelper.isCheckUserMail();
        $pwdInput.val('');
        this.$el.find(this.selectors.recoverPassword).addClass('hidden');
        this.$el.find(this.selectors.userLogin).removeClass('hidden');
        this.$el.find(this.selectors.recoverPasswordForm).removeClass('hidden');
        this.$el.find(this.selectors.recoverPasswordWaiting).addClass('hidden');
        this.$el.find(this.selectors.recoverPasswordInformation).addClass('hidden');
        $emailInput.attr('readOnly', isCheckUserMail);
        renderCaptcha.call(this, 'recaptchaLogin', this.resumeLoginSubmitRequest);
        if (isCheckUserMail) {
            $emailInput.val(userHelper.getEmailFromStorageSession());
            $pwdInput.focus();
        } else {
            $emailInput.focus();
        }
    },

    renderCaptcha(isLoginForm) {
        if (isLoginForm) {
            renderCaptcha.call(this, 'recaptchaLogin', this.resumeLoginSubmitRequest);
        } else {
            renderCaptcha.call(this, 'recaptchaPassRecovery', this.resumeRecoverPasswordSubmitRequest);
        }
    },

    recaptchaExecutionCallback: function(selector, submitFunction) {
        this.model.requestData.recaptchaResponse = recaptchaManager.gRecaptchaGetResponse(this.model.recaptchaWidgetID[selector]);
        submitFunction.call(this);
        Odigeo.Session.set('loginRequested', true);
    },

    checkPrimePostbookingEmail: (userEmail) => {
        const postbookingEmail = Odigeo.Session.get('loginEmailPostbooking') || '';
        return postbookingEmail === userEmail;
    },

    onChangeInput: function(e) {
        if (Odigeo.AB.isCssVariationDesktop) {
            loginvalidator.clearErrors($(e.currentTarget));
            loginvalidator.checkValidity($(e.currentTarget), this.$el);
        }
    },

    loginWithPassword() {
        let data;
        let fieldErrors;
        const allInputs = this.$el.find(this.selectors.loginUserWithPassword).find('[data-name]:not([type="hidden"])');
        loginvalidator.clearErrors(allInputs, this.$el.find(this.selectors.socialError));
        fieldErrors = loginvalidator.checkValidity(allInputs, this.$el);
        Odigeo.Session.set('loginWidget', this.id);
        Odigeo._.each(fieldErrors, function(element) {
            this._trackError(element);
        }, this);

        const isPrimePostBookingPage = Odigeo.History.getPageNameFromFragment() === 'primepostbooking';
        const login = this.$el.find(this.selectors.emailInput).val();
        const errorPostbookingEmail = isPrimePostBookingPage && !this.checkPrimePostbookingEmail(login);
        if (errorPostbookingEmail) {
            this.showGenericError(this.$el.find(this.selectors.loginError), 'postbookingemailerror');
        }
        if (this.model.logged === false && Odigeo._.isEmpty(fieldErrors) && !errorPostbookingEmail) {
            data = {
                login,
                password: this.$el.find(this.selectors.passwordInput).val(),
                loginType: 'password',
                persistentLogin: this.model.isPersistentLogin,
            };
            this._login(data);
        }
    },

    openRecoverPasswordForm: function() {
        this.trackEvent(this.model.trackCategory, 'sign_in', 'forgot_password_clicks');
        this.$el.find(this.selectors.userLogin).addClass('hidden');
        this.$el.find(this.selectors.recoverPassword).removeClass('hidden');
        this.$el.find(this.selectors.recoverPasswordEmail).removeClass('invalid invalid-long');
        this.$el.find(this.selectors.emailRecoverPasswordInput).val(this.$el.find(this.selectors.emailInput).val()).focus();
        renderCaptcha.call(this, 'recaptchaPassRecovery', this.resumeRecoverPasswordSubmitRequest);
    },

    recoverPassword() {
        this.hideGenericError();
        this.$el.find(this.selectors.recoverPasswordEmail).removeClass('invalid invalid-long');
        this.$el.find(this.selectors.recoverPasswordEmail).find('.error_long_message').text('');
        this.$el.find(this.selectors.recoverPasswordEmail).find('.error_message').text('');

        const email = this.$el.find(this.selectors.emailRecoverPasswordInput).val();

        Odigeo.Session.set('loginWidget', this.id);
        if (Odigeo.Utils.isValidEmail(email)) {
            if (Odigeo.AB.isRecaptchaEnabled) {
                recaptchaManager.gRecaptchaExecute(this.model.recaptchaWidgetID['recaptchaPassRecovery']);
            } else {
                this.resumeRecoverPasswordSubmitRequest();
            }
        } else {
            this.trackEvent(this.model.trackCategory, 'password_recovery', 'sso_email_incorrect_format_error');
            var errorText = this.$el.find(this.selectors.emailRecoverPasswordInput).data((email === '') ? 'empty' : 'invalid');
            var isLongError = loginvalidator.errorLenghtOverMax(errorText);
            this.$el.find(this.selectors.recoverPasswordEmail).addClass(isLongError ? 'invalid-long' : 'invalid');
            this.$el.find(this.selectors.recoverPasswordEmail).find(isLongError ? '.error_long_message' : '.error_message')
                .text(errorText);
        }
    },

    // TODO: Decouple logic from login widget!
    goToMyTrips() {
        const {logged} = this.model;
        if (logged) {
            Odigeo.trigger(`${this.id}:${TO_MY_TRIPS_EVENT_NAME}`);
            trackMyTripDetailsAccess(logged);
        } else {
            this.openModalLogin();
        }
        trackNextSteps('flights', logged);
    },

    fromDeepLinkToDetails(flow) {
        const {logged} = this.model;
        trackMyTripDetailsAccess(logged);
        trackNextSteps(flow, logged);
        Odigeo.trigger(`${this.id}:${TO_TRIP_DETAILS_EVENT_NAME}`);
    },
    // End coupling.

    resumeRecoverPasswordSubmitRequest() {
        const email = this.model.get('isBlockedUser') ? this.model.requestData.login : this.$el.find(this.selectors.emailRecoverPasswordInput).val();
        Odigeo._.each(this.$el.find(this.selectors.userEmail), function(userEmail) {
            userEmail.innerHTML = email;
        });
        this.$el.find(this.selectors.recoverPasswordWaiting).removeClass('hidden');
        this.model.requestData.email = email;
        this.model.action = 'recoverPassword';
        this.trackEvent(this.model.trackCategory, 'password_recovery', 'send_instructions');
        if (!this.options.noModalDialogs) {
            this.$el.find(this.selectors.recoverPassword).addClass('hidden');
        }
        this.model.isLegacyUser = false;
        this.triggerSubmitRequest();
    },

    recoverPasswordSuccess: function() {
        Odigeo.Session.remove('loginRequested');
        if (Odigeo.AB.isRecaptchaEnabled) {
            recaptchaManager.gRecaptchaReset(this.model.recaptchaWidgetID['recaptchaPassRecovery']);
        }
        this.trackEvent(this.model.trackCategory, 'password_recovery_email', 'pwd_recovery_email_sent');
        this.$el.find(this.selectors.recoverPasswordWaiting).addClass('hidden');
        this.$el.find(this.selectors.recoverPasswordForm).addClass('hidden');
        this.$el.find(this.selectors.recoverPasswordInformation).removeClass('hidden');
        this.$el.find(this.selectors.recoverPassword).removeClass('hidden');
        if (this.model.get('isBlockedUser')) {
            Odigeo.Router.navigate('accountblocked');
        }
    },

    recoverPasswordError: function(data) {
        Odigeo.Session.remove('loginRequested');
        if (Odigeo.AB.isRecaptchaEnabled) {
            recaptchaManager.gRecaptchaReset(this.model.recaptchaWidgetID['recaptchaPassRecovery']);
        }
        const error = data.messageError && this.model.errors[data.messageError];
        const errorText = this.$el.find(this.selectors.emailRecoverPasswordInput).data(error ? this.model.errors[data.messageError] :
            'notverifiedaccount');

        this.$el.find(this.selectors.recoverPasswordWaiting).addClass('hidden');
        this.$el.find(this.selectors.recoverPasswordForm).removeClass('hidden');
        this.$el.find(this.selectors.recoverPassword).removeClass('hidden');
        loginvalidator.clearErrors(this.$el.find(this.selectors.loginUserWithPassword).find('[data-name]:not([type="hidden"])'));
        if (!Odigeo._.isUndefined(error) && error.indexOf('recaptcha') !== -1) {
            this.showGenericError(this.$el.find(this.selectors.passRecoveryError), 'recaptchaerror');
            this.trackRecaptchaError('odigeo_recaptcha_error_forgot-pass');
        } else if (error === 'remoteError') {
            this.showGenericError(this.$el.find(this.selectors.passRecoveryError), 'remoteerror');
        } else {
            this.$el.find(this.selectors.recoverPasswordEmail).addClass('invalid');
            this.showErrorNoTrack(errorText, this.$el.find(this.selectors.emailRecoverPasswordInput).closest('.input_wrapper'));
        }
    },

    showSocialErrorNoTrack: function(errorText, $wrapper) {
        const isLongError = loginvalidator.errorLenghtOverMax(errorText);
        this.$el.find(this.selectors.loginSocialError).find(isLongError ? '.error_long_message' : '.error_message').text(errorText);
        this.$el.find(this.selectors.loginSocialError).addClass('invalid');
        $wrapper.addClass('invalid');
    },

    showErrorNoTrack: function(errorText, $wrapper) {
        const isLongError = loginvalidator.errorLenghtOverMax(errorText);
        $wrapper.find(isLongError ? '.error_long_message' : '.error_message').text(errorText);
        $wrapper.addClass(isLongError ? 'invalid invalid-long' : 'invalid');
    },

    showModalLoginForm() {
        Odigeo.trigger('closeAllPopUps');
        loginvalidator.clearErrors(this.$el.find(this.selectors.loginUserWithPassword).find('[data-name]:not([type="hidden"])'),
            this.$el.find(this.selectors.socialError));
        this.openLoginForm();
        if (!this.options.noModalDialogs) {
            this.$el.find(this.selectors.modalView).addClass('active open opened');
        }
        this.$el.find(this.selectors.loginSuccess).addClass('hidden');
        this.$el.find(this.selectors.loginWaiting).addClass('hidden');
        this.$el.find(this.selectors.loginConnectors).addClass('opened');
        this.$el.find(this.selectors.emailInput).focus();
    },

    closeConnectorsLayer() {
        this.$el.find(this.selectors.passwordInput).val('');
        this.$el.find(this.selectors.loginConnectors).removeClass('opened');
        this.$el.find(this.selectors.modalView).removeClass('active open opened');
    },

    stopPropagationClose(e) {
        e.stopPropagation();
    },

    changePasswordCharsViewer: function(evt) {
        this.$el.find(this.selectors.passwordIcon).find('.password_char_viewer').toggleClass('odf-hidden');

        this.$el.find(this.selectors.passwordInput).attr('type',
            this.$el.find(this.selectors.passwordInput).attr('type') === 'password' ? 'text' : 'password'
        );
    },

    showPasswordCharsIcon: function(e) {
        this.$el.find(this.selectors.passwordIcon).removeClass('odf-hidden');
        $(e.target).off();
    },

    loginWithFacebookOk(data) {
        let undef;
        this.hideUserLogin();
        socialLogin.addTravellerToAccount(data, this.id, undef, socialLogin.socialLoginType.facebook);
        this._anyLoginOk(data, 'sso_successful_login_facebook');
    },

    loginWithGoogleOk(data) {
        this.hideUserLogin();
        socialLogin.addTravellerToAccount(data, this.id);
        this._anyLoginOk(data, 'sso_successful_login_google');
    },

    loginOk(data) {
        this._anyLoginOk(data, 'sso_successful_login_odigeo');
    },

    loginWithError(data) {
        this.model.logged = false;
        this.model.models.user = null;
        if (!this.isAccountBlocked(data)) {
            this.loginError(data);
            Odigeo.trigger(this.id + ':userNotLogged');
        } else {
            this.closeConnectorsLayer();
        }
        Odigeo.Session.remove('loginRequested');
    },

    successfullLogin(data) {
        this.showModalLoginForm();
        this.$el.find(this.selectors.loginUserWithPassword).addClass('hidden');
        this.$el.find(this.selectors.headerDialog).addClass('hidden');
        this.loginOk(data);
    },

    _anyLoginOk(data, tracking, isSuccessPopUpDisabled) {
        if (Odigeo.AB.isRecaptchaLoginEnabled) {
            recaptchaManager.gRecaptchaReset(this.model.recaptchaWidgetID['recaptchaLogin']);
        }
        this.model.loggedOnHttps = true;
        this.setEmailValues(data);
        const isMembershipLoginFeedbackActive = Odigeo.Membership.isMembershipProductEnabled && data.membership;
        if (!isSuccessPopUpDisabled && !isMembershipLoginFeedbackActive) {
            this.showLoginSuccess();
        }
        this.isLoggedInOk(data, tracking);
        Odigeo._.delay(Odigeo._.bind(function() {
            this.closeConnectorsLayer();
            this.hideLoginSuccess();
            Odigeo.trigger(this.id + ':anyLoginOk', data);
        }, this), 1500);
    },

    isLoggedInOk(data, tracking) {
        const trackLabel = tracking || 'sso_successful_login_' + Odigeo.Session.get('loginPassword');
        this.model.models.user = data;
        this.model.trackCategory =
            Odigeo.Session.get('loginWidget') === 'my-trips-login-form' ? 'sso_sign_in_trips' : 'sso_module';
        if (!this.model.logged) {
            this.model.logged = true;
            this.model.membershipDisplayName = data.displayName;
            this.model.isMembership = data.membership;
            this.hideLoginWaiting();
            if (this.options.firstLogin || this.model.loggedOnHttps) {
                this.model.loggedOnHttps = false;
            }
            // Analytics: virtual page tracking
            this._tracktCustomVar(true);
        }
        if (tracking) {
            this.trackEvent(this.model.trackCategory, 'sign_in', trackLabel);
        }
        tagManagement.fireEvent('login_success', 'customer_email', Odigeo._.get(data, 'userDTO.email'));

        this.setMembershipCustomDimension();
        Odigeo.Session.remove('loginRequested');
        Odigeo.trigger(this.id + ':userLogged', data, true);
    },

    setMembershipCustomDimension() {
        const membershipCustomDimensionCookie = Odigeo.Utils.readCookie('ua_dimension31');

        trackingUtils.setCustomDimension(31, membershipCustomDimensionCookie);
    },

    openModalLogin() {
        Odigeo._.delay(Odigeo._.bind(function() {
            this.showModalLoginForm();
        }, this), 250);
    },

    openModalLogout(data) {
        const shouldOpenModal = this.model.isMembership;
        if (shouldOpenModal) {
            this.launchLogoutModal(data);
        } else {
            Odigeo.trigger(this.id + ':userLogoutConfirmed', data);
        }
    },

    launchLogoutModal(data) {
        const lightBoxTexts = {
            headerTitle: this.keys.lightboxTextsHeader,
            description: this.keys.lightboxTextsDescription,
            primaryButton: this.keys.lightboxTextsPrimary,
            secondaryButton: this.keys.lightboxTextsSecondary,
        };
        const filledDescription = Odigeo.Utils.replaceCmsKeyArgs(lightBoxTexts.description,
            this.model.membershipDisplayName);
        trackingUtils.trackEvent('unlocked', 'nag_logout_displayed', null, true);
        Odigeo.UIElements.showLightboxWarning('od-passenger-lightbox-logout',
            Odigeo._.bind(this.onLaunchLogoutModalAction, this, data),
            Odigeo._.bind(this.onLaunchLogoutModalCancel, this),
            Odigeo._.extend({}, lightBoxTexts, {description: filledDescription}));
    },

    onLaunchLogoutModalAction(data) {
        trackingUtils.trackEvent('unlocked', 'nag_logout_confirm');
        Odigeo.trigger(this.id + ':membershipLogoutPopUpConfirmation', Odigeo._.extend({isMembershipLogout: true}, data));
    },

    onLaunchLogoutModalCancel(isCancelButton) {
        const eventLabel = isCancelButton === true ? 'nag_logout_cancel' : 'nag_logout_close';
        trackingUtils.trackEvent('unlocked', eventLabel);
        Odigeo.trigger('closeAllPopUps');
    },

    recoverPasswordOk() {
        if (!this.model.isLegacyUser) {
            this.recoverPasswordSuccess();
        }
    },

    // todo: login widget refactor pending. Define a proper onLogoutEvent function in handler
    _logoutActions() {
        this.model.logged = false;
        Odigeo.Session.remove('loginRequested');
        Odigeo.Session.remove('loginPassword');
        Odigeo.trigger(this.id + ':userNotLogged');
        this._tracktCustomVar(false);
    },

    checkLogged() {
        if (Odigeo._.isEmpty(this.options.loginError)) {
            Odigeo.trigger(this.id + ':submitUserRequest', {data: '', action: 'isLoggedIn'});
        } else { // There was an error in the login with http
            this.loginWithError({messageError: this.options.loginError});
        }
        if (!Odigeo._.isEmpty(this.options.lastLoginEmailUsed)) {
            this.updateEmailInput();
        }
    },

    checkNoModalWidget() {
        // TODO: remove condition when desktop login template is in odf
        if (Odigeo.SessionScope.flow === 'mobile' && Odigeo.AB.isCssVariationMobile) {
            this.$el.find(this.selectors.userLogin).toggleClass('prisma-lightbox-wrapper', !this.options.noModalDialogs);
            this.$el.find(this.selectors.userLoginHeader).toggleClass('prisma-lightbox-header', !this.options.noModalDialogs);
            this.$el.find(this.selectors.modalView).toggleClass('prisma-lightbox-bg', !this.options.noModalDialogs);
            this.$el.find(this.selectors.modalViewContent).toggleClass('prisma-lightbox', !this.options.noModalDialogs);
        } else if (this.id === 'my-trips-login-form' && Odigeo.SessionScope.flow === 'desktop' && Odigeo.AB.isCssVariationHeaderDesktop) {
            this.$el.find(this.selectors.userLogin).toggleClass('prisma-lightbox-wrapper', !this.options.noModalDialogs);
            this.$el.find(this.selectors.userLogin).toggleClass('prisma-elevation-2', !this.options.noModalDialogs);
            this.$el.find(this.selectors.userLoginHeader).toggleClass('odf-hidden', this.options.noModalDialogs);
            this.$el.find(this.selectors.userLoginContent).toggleClass('prisma-lightbox-content', !this.options.noModalDialogs);
            this.$el.find(this.selectors.userLoginContent).toggleClass(
                'odf-space-inner-left-l odf-space-inner-right-l',
                !this.options.noModalDialogs);
            this.$el.find(this.selectors.modalView).toggleClass('prisma-lightbox-bg', !this.options.noModalDialogs);
            this.$el.find(this.selectors.modalViewContent).toggleClass('prisma-lightbox', !this.options.noModalDialogs);
            this.$el.find(this.selectors.modalViewContent).toggleClass('od-login-non-modal-width', this.options.noModalDialogs);
        } else {
            if (Odigeo.SessionScope.flow === 'mobile') {
                this.$el.find(this.selectors.userLogin).toggleClass('odf-box odf-box-layer', !this.options.noModalDialogs);
                this.$el.find(this.selectors.userLoginHeader).toggleClass('odf-box-layer-header', !this.options.noModalDialogs);
            }
            this.$el.find(this.selectors.modalView).toggleClass('odf-lightbox-bg', !this.options.noModalDialogs);
            this.$el.find(this.selectors.modalViewContent).toggleClass('odf-lightbox', !this.options.noModalDialogs);
        }
    },

    _showSocialLoginError: function(error, loginType) {
        const loginTypeFormatted = Odigeo._.startCase(loginType);
        loginvalidator.clearErrors(this.$el.find(this.selectors.loginUserWithPassword).find('[data-name]:not([type="hidden"])'),
            this.$el.find(this.selectors.socialError));
        this.trackEvent(this.model.trackCategory, 'sign_in', 'sso_email_authentication_' + loginType + '_error');
        this.showSocialErrorNoTrack(this.$el.find(this.selectors['login' + loginTypeFormatted + 'Button']).data(error),
            this.$el.find(this.selectors['login' + loginTypeFormatted + 'Error']));
    },

    checkLoginFacebookState() {
        socialLogin.getLoginStatus(this.id);
        loginvalidator.clearErrors(this.$el.find(this.selectors.loginUserWithPassword).find('[data-name]:not([type="hidden"])'),
            this.$el.find(this.selectors.socialError));
    },

    checkLoginGoogleState() {
        socialLogin.getLoginStatusGoogle(this.id);
        loginvalidator.clearErrors(this.$el.find(this.selectors.loginUserWithPassword).find('[data-name]:not([type="hidden"])'),
            this.$el.find(this.selectors.socialError));
    },

    _login: function(data) {
        this.model.requestData = Odigeo._.omit(data, ['loginType']);
        this.model.action = this.model.loginActions[data.loginType];
        this.model.loginType = data.loginType.toUpperCase();
        this.model.socialToken = data.token;
        this.hideGenericError();
        if (Odigeo.AB.isRecaptchaLoginEnabled && !this.model.socialToken && location.protocol !== 'http:') {
            recaptchaManager.gRecaptchaExecute(this.model.recaptchaWidgetID['recaptchaLogin']);
        } else {
            this.resumeLoginSubmitRequest();
        }
    },

    resumeLoginSubmitRequest() {
        const labelLoginType = this.model.loginType.toLowerCase();
        if (!this.options.noModalDialogs) {
            this.$el.find(this.selectors.userLogin).addClass('hidden');
        }
        this.$el.find(this.selectors.loginWaiting).removeClass('hidden');
        this.$el.find(this.selectors.modalView).off();
        var loginTypeRequested = Odigeo.Session.get('loginRequested');
        if (this.model.socialToken && !loginTypeRequested) {
            Odigeo.Session.set('loginPassword', labelLoginType);
        } else {
            Odigeo.Session.set('loginPassword', 'odigeo');
        }
        Odigeo.Session.set('loginRequested', labelLoginType);
        Odigeo.Session.remove('feedbackPrime');
        if (location.protocol === 'http:') {
            this._addHiddenInput('login_type', this.model.loginType);
            if (!Odigeo._.isUndefined(this.model.socialToken)) {
                this._addHiddenInput('accessToken', this.model.socialToken);
            }
            this._addHiddenInput('url', document.URL);
            this.$el.find(this.selectors.loginUserWithPassword).attr('action',
                'https://' + document.domain + Odigeo.Settings.property('appContext') + '/secure/login');

            this.$el.find(this.selectors.loginUserWithPassword).submit();
        } else if (!loginTypeRequested) {
            Odigeo.trigger(this.id + ':submitUserRequest', {
                'data': this.model.requestData,
                'action': this.model.loginActions[this.model.loginType.toLowerCase()],
            });
        }
    },

    triggerSubmitRequest() {
        Odigeo.trigger(this.id + ':submitUserRequest', {
            'data': this.model.requestData,
            'action': this.model.action,
        });
    },

    setEmailValues: function(data) {
        Odigeo._.each(this.$el.find(this.selectors.userEmail), function(userEmail) {
            userEmail.innerHTML = data.displayName;
        });
    },

    onBackToLogin: function() {
        const action = this.$el.find(this.selectors.recoverPasswordForm).hasClass('hidden') ? 'password_recovery_email' : 'password_recovery';
        this.trackEvent(this.model.trackCategory, action, 'go_to_login');
        this.openLoginForm();
    },

    onLoginSubmit: function() {
        const persistentLoginLabel = `persistent-login_continue:checked_pag:${this.model.trackPage}`;

        this.trackEvent(this.model.trackCategory, 'sign_in', persistentLoginLabel);
        this.loginWithPassword();
    },

    onLoginFacebook: function() {
        this.trackEvent(this.model.trackCategory, 'sign_in', 'sign_in_facebook');
        this.checkLoginFacebookState();
    },

    onLoginGoogle: function() {
        this.trackEvent(this.model.trackCategory, 'sign_in', 'sign_in_google');
        this.checkLoginGoogleState();
    },

    displayLoginOk: function(data) {
        this.showModalLoginForm();
        this.$el.find(this.selectors.userLogin).addClass('hidden');
        this.$el.find(this.selectors.loginSuccess).removeClass('hidden');
        this.setEmailValues(data);
        Odigeo._.delay(Odigeo._.bind(function() {
            this.$el.find(this.selectors.loginWaiting).addClass('hidden');
            this.$el.find(this.selectors.loginSuccess).addClass('hidden');
        }, this), 1500);
    },

    embedWidget() {
        this.$el.find(this.selectors.loginConnectors).toggleClass('od-login-content-wrapper', !this.options.noModalDialogs);
        this.$el.find(this.selectors.userLogin).toggleClass('od-hint-content', !this.options.noHint);
        this.$el.find(this.selectors.modalArtifacts).toggleClass('odf-hidden', this.options.noModalDialogs);
    },

    hideShowRegisterFooterLink: function(isVisible) {
        this.$el.find(this.selectors.registerFooter).toggleClass('hidden', !isVisible);
    },

    hideEmailLogin: function(hide) {
        this.$el.find(this.selectors.emailLoginContainer).toggleClass('hidden', hide);
    },

    showSocialLoginButton(button) {
        this.$el.find(this.selectors.loginUserSocial).addClass('odf-hidden');
        this.$el.find(this.selectors['loginUserWith' + Odigeo.Utils.capitalize(button)]).removeClass('odf-hidden');
    },

    updateEmailInput() {
        this.$el.find(this.selectors.emailInput).val(this.options.lastLoginEmailUsed);
    },

    hideLoginWaiting: function() {
        this.$el.find(this.selectors.loginWaiting).addClass('hidden');
    },

    hideLoginSuccess: function() {
        this.$el.find(this.selectors.loginSuccess).addClass('hidden');
    },

    showLoginSuccess: function() {
        this.$el.find(this.selectors.loginSuccess).removeClass('hidden');
    },

    hideUserLogin: function() {
        this.$el.find(this.selectors.userLogin).addClass('hidden');
    },

    checkMembershipFastMenu(isMembership, isPendingToCollect) {
        Odigeo.trigger(this.id + ':setMembershipStar', this.isMembership || isMembership);
        Odigeo.trigger(this.id + ':setLoginAndSecurityFastMenu', this.isMembership || isMembership, isPendingToCollect);
    },

    initEmbedView(button) {
        this.hideShowRegisterFooterLink(false);
        this.hideEmailLogin(true);
        this.showSocialLoginButton(button);
        this.embedWidget();
    },

    performUserRequestIfLogged(params, notLoggedCallback) {
        if (this.model.logged) {
            Odigeo.trigger(this.id + ':performUserRequest', params);
        } else if (Odigeo._.isFunction(notLoggedCallback)) {
            notLoggedCallback();
        }
    },

    trackEvent(category, action, label) {
        trackingUtils.trackEventWithCategory(category, action, label);
    },

    onFocusInput: function(e) {
        $(e.target).closest(this.selectors.prismaInput).addClass('focused');
    },

    onBlurInput: function(e) {
        $(e.target).closest(this.selectors.prismaInput).removeClass('focused');
    },

}));
